import { render, staticRenderFns } from "./VmsList.vue?vue&type=template&id=7a10819b&scoped=true&"
import script from "./VmsList.vue?vue&type=script&lang=js&"
export * from "./VmsList.vue?vue&type=script&lang=js&"
import style0 from "./VmsList.vue?vue&type=style&index=0&id=7a10819b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10819b",
  null
  
)

export default component.exports